export const ExternalLinks = {
  CIDM: 'https://cidm.roche.com',
} as const;
